import { OnInit, Component, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserService } from '../../service/common/user.service';
import { TranslateService } from '@ngx-translate/core';
import { UserRoleService } from '../../service/common/user-role.service';
import { ShowViewerArgs } from '../../models/viewer/ShowViewerArgs.model';
import { ExtensionInterface } from '../../models/viewer/ExtensionInterface.model';
import { CORE } from '../../models/viewer/CORE.model';
declare var $: any;

@Component({
    selector: 'stp-configure',
    template: `<!-- <div class="row">
    <div class="regularObjectBorder justRightBorder">
        <button (click)="setCurrentTab('GRAPHIC')">Graphic file</button>
    </div>
    <div class="regularObjectBorder justRightBorder">
        <hc-button (click)="setCurrentTab('POSITION')">Orientation/Positioning</hc-button>
    </div>
    <div class="regularObjectBorder justRightBorder">
        <hc-button (click)="showArmsConfiguration(); setCurrentTab('ARMS');">Arms confiugration</hc-button>
    </div>
    <div class="regularObjectBorder justRightBorder">
        <hc-button (click)="setCurrentTab('PROFILE')">Profile confiugration</hc-button>
    </div>
    <div class="regularObjectBorder justRightBorder">
        <hc-button (click)="setCurrentTab('BUTTONS')">Buttons confiugration</hc-button>
    </div>
    <div class="regularObjectBorder justRightBorder">
        <hc-button (click)="setCurrentTab('PARTLIST')">Part list</hc-button>
    </div>
    <i class="material-icons btn-close" (click)="closeViewer()">close</i>
</div> -->

<ul class="steps" *ngIf="args.itemType === 'CONNECTOR' || args.itemType === 'BASE' || args.itemType === 'PIPE_FASTENING'">
    <!-- <li class="step">
        <button class="btnStep" (click)="setCurrentTab('GRAPHIC')">Graphic file</button>
    </li> -->
    <li class="step">
        <button class="btnStep" [class.currentTab]="'POSITION' === currentTab" (click)="setCurrentTab('POSITION')">Orientation/Positioning</button>
    </li>
    <li class="step">
        <button class="btnStep" [class.currentTab]="'ARMS' === currentTab" (click)="armsConfigure.showArmsConfiguration(); setCurrentTab('ARMS');">Arms configuration</button>
    </li>
    <li *ngIf="args.variantId !== null" class="step">
        <button class="btnStep" [class.currentTab]="'PROFILE' === currentTab" (click)="profilesConfigure.showProfilesConfiguration(); setCurrentTab('PROFILE')">Profile configuration</button>
    </li>
    <li *ngIf="args.variantId !== null" class="step">
        <button class="btnStep" [class.currentTab]="'BUTTONS' === currentTab" (click)="setCurrentTab('BUTTONS')">Buttons configuration</button>
    </li>
    <li class="step">
        <button class="btnStep" [class.currentTab]="'PARTLIST' === currentTab" (click)="setCurrentTab('PARTLIST')">Part list</button>
    </li>
</ul>
<ul class="steps" style="justify-content: space-around !important;" *ngIf="args.itemType === 'PIPE_RING' && args.variantId !== null">
    <li class="step">
        <button class="btnStep clickable" [class.currentTab]="'PIPE_CONFIGURE' === currentTab" (click)="setCurrentTab('PIPE_CONFIGURE')">Configuration</button>
    </li>
    <li class="step">
        <button class="btnStep clickable" [class.currentTab]="'ROD_CONFIGURE' === currentTab" (click)="setCurrentTab('ROD_CONFIGURE')">Display configuration</button>
    </li>
</ul>
<i class="material-icons btn-close" (click)="closeViewer()">close</i>
<div id="canvasesContainer" [style.height]="calculateHeight()">
    <part-list *ngIf="'PARTLIST' === currentTab" [ExtensionInterface]="ExtensionInterface" [args]="args"></part-list>
            <pipering-configure *ngIf="'PIPE_CONFIGURE' === currentTab" [Args]="args"></pipering-configure>
    <div class="display-flex" [style.height]="calculateHeight()">
        <div class="col-7">
            <iframe [hidden]="'PARTLIST' === currentTab || 'PIPE_CONFIGURE' === currentTab" scrolling="no" id="viewerIframe" style="width: 100%; height: 100%; border:none"></iframe>
        </div>
        <div class="col-5">
            <arms-configure #armsConfigure [hidden]="currentTab !== 'ARMS'" [ExtensionInterface]="ExtensionInterface"></arms-configure>
            <profiles-configure *ngIf="args.variantId !== null" #profilesConfigure [hidden]="currentTab !== 'PROFILE'" [ExtensionInterface]="ExtensionInterface"></profiles-configure>
            <orientation-positioning [hidden]="currentTab !== 'POSITION'" [ExtensionInterface]="ExtensionInterface"></orientation-positioning>
            <!-- <threaded-configure *ngIf="'ROD_CONFIGURE' === currentTab" #rodConfigure [Args]="args"></threaded-configure> -->
        </div>
    </div>
</div>`,
    styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:1px}tr:nth-child(even){background-color:#ddd}.icon-button{cursor:pointer;font-size:30px;vertical-align:middle}.icon-button .close-icon{cursor:pointer;position:absolute;right:10px}.steps{display:flex;list-style:none;align-items:center;margin:0;height:60px;padding:0;justify-content:space-between}.btnStep{color:#000;font-weight:700;font-size:14px;letter-spacing:.5px;background-color:transparent;border:0;outline:0}.btnStep:disabled{opacity:.6!important;cursor:default}.step::before{background-color:#ccc9cc;margin-left:16px;min-width:70%;height:2px}.step:nth-child(1) .btnStep::before{content:"1"}.step:nth-child(2) .btnStep::before{content:"2"}.step:nth-child(3) .btnStep::before{content:"3"}.step:nth-child(4) .btnStep::before{content:"4"}.step:nth-child(5) .btnStep::before{content:"5"}.step:nth-child(6) .btnStep::before{content:"6"}.btnStep::before{display:inline-block;width:40px;min-width:40px;height:40px;border:0;border-radius:50%;right:0;background-color:#000;margin-right:12px;text-align:center;color:#fff;line-height:40px;font-size:13px}.arms-table{bottom:41px;right:18px;height:100%;background-color:#fff}.arms-table td,.arms-table th{text-align:center}.red-button{font-family:inherit;padding:7px 14px}.currentTab::before{background-color:#d0021b!important}.display-flex{display:flex;margin-bottom:10px}`]
})

export class StpConfigureComponent implements OnInit {
    @ViewChild('armsConfigure') armsConfigure;
    //@ViewChild('armsConfigure2') armsConfigure2;
    @ViewChild('profilesConfigure') profilesConfigure;
    @ViewChild('rodConfigure') rodConfigure;
    @Input() args: ShowViewerArgs;
    @Output() onShowViewer: EventEmitter<ShowViewerArgs> = new EventEmitter();
    maximized = false;
    viewerIframeId = 'viewerIframe';
    CORE: CORE = null;
    ExtensionInterface: ExtensionInterface = null;
    public currentTab: string;

    constructor(private user: UserService,
        private translate: TranslateService,
        private userRoleService: UserRoleService
    ) { }

    ngOnInit(): void {
        this.initView();
    }
    initView() {
        const useProd = environment.production === true;
        const rootPath = '/viewer-lib/';

        ///////
        if (useProd === true) {
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'viewer.min.css" type="text/css" />');
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'js/lib/bootstrap-switch/bootstrap-switch.min.css">');
        } else {
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'css/override.css" type="text/css" />');
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'css/VIEWUI.css" type="text/css" />');
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'css/VIEWUI.popups.css" type="text/css" />');
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'css/VIEWUI.properties.css" type="text/css" />');
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'css/VIEWUI.viewTree.css" type="text/css" />');
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'css/dark-theme.css" type="text/css" />');
            $('head').append('<link rel="stylesheet" href="' + rootPath + 'js/lib/bootstrap-switch/bootstrap-switch.min.css">');
        }

        let innerHtml = '<div style="width: calc(100vw); height: height: calc(100vh - 2px)"><div id="canvasesContainer" style="width: 100%; height: 100%"></div></div>';
        innerHtml += '<script src="/viewer-lib/js/lib/jquery.min.js"></script>';
        innerHtml += `<script type="text/javascript">
        initViewerLibrary = function(subProjectId, apiUri, constraintsUri, authData, lang, parent, useProd, viewerLoadingStart, angularEnvName, hideIcon) {
            $.getScript('/viewer-lib/js/lib/jquery-ui/jquery-ui.min.js').done(function () {
                $.getScript('/viewer-lib/js/loader.js').done(function () {
                    $('#canvasesContainer').constructionViewer({
                        rootPath: '/viewer-lib/',
                        disableLoadAndSave: false,
                        loadResources: true,
                        showObjectList: false,
                        showToolbar: false,
                        demoMode: false,
                        useOrthographicProjection: true,
                        hideWorkplane: true,
                        subProjectId: subProjectId,
                        apiUri: apiUri,
                        constraintsUri: constraintsUri,
                        authData: authData,
                        language: lang,
                        useProd: useProd,
                        viewerLoadingStart: viewerLoadingStart,
                        angularEnvName: angularEnvName,
                        hideIcon: hideIcon,
                        callback: ((state) => Extension.loadStp('` + this.args.itemId + `', '` + this.args.itemType + `', '` + this.args.variantId + `'))
                    });
                });
            })    
            .fail(function (jqxhr, settings, exception) {
                console.error('CONSTRUCTION VIEWER preloader: loader.js loading failed, error: ' + exception);
            });
        }
        </script>
        <style type="text/css">@import url(https://fonts.googleapis.com/icon?family=Material+Icons);</style>`;

        let ifrm = (<any>document.getElementById(this.viewerIframeId));
        ifrm = ifrm.contentWindow || ifrm.contentDocument.document || ifrm.contentDocument;
        ifrm.document.open();
        ifrm.document.write(innerHtml);
        ifrm.document.close();

        const subProjectId = 0;
        const apiUri = environment.serviceUrl;
        const constraintsUri = environment.constraintsUrl;
        const authData = this.user.authentication;
        let lang = this.translate.currentLang;
        if (!lang) {
            lang = this.translate.getDefaultLang();
        }
        lang = "en";
        const parent = this;
        const viewerLoadingStart = performance.now();
        const angularEnvName = environment.envName;
        const hideIcon = !(this.userRoleService.canPerformCalculations());

        let startViewerTaskCounter = 50;
        let viewerStarted = false;
        const startViewerTask = setInterval(() => {
            if ('initViewerLibrary' in ifrm) {
                ifrm.initViewerLibrary(subProjectId, apiUri, constraintsUri, authData, lang, parent, useProd, viewerLoadingStart, angularEnvName, hideIcon);
                startViewerTaskCounter = 0;
                viewerStarted = true;
            } else {
                startViewerTaskCounter--;
            }
            if (startViewerTaskCounter === 0) {
                clearInterval(startViewerTask);
                if (!viewerStarted) {
                    alert('Viewer could not be loaded in time. Please reload the page or restart the browser.');
                }
            }
        }, 200);

        let getCoreTaskCounter = 75;
        let coreFound = false;
        let context = this;
        let windowOpen = window.open;
        const getCoreTask = setInterval(() => {
            if ('CORE' in ifrm && 'ExtensionInterface' in ifrm) {
                context.CORE = ifrm.CORE;
                context.ExtensionInterface = ifrm.ExtensionInterface;
                context.ExtensionInterface.isVariantChoosen = (this.args.variantId !== null);
                context.CORE.parentWindowOpen = windowOpen;
                if (this.args.itemType === 'PIPE_RING') {
                    context.currentTab = context.ExtensionInterface.isVariantChoosen ? 'PIPE_CONFIGURE' : 'ROD_CONFIGURE';
                    // context.currentTab = 'PIPE_CONFIGURE';
                } else {
                    context.currentTab = context.ExtensionInterface.isVariantChoosen ? 'PROFILE' : 'POSITION';
                }
                context.CORE.isAuthenticatedFunc = function () {
                    return context.user.isAuthenticated;
                };
                getCoreTaskCounter = 0;
                coreFound = true;
            } else {
                getCoreTaskCounter--;
            }
            if (getCoreTaskCounter === 0) {
                clearInterval(getCoreTask);
                if (!coreFound) {
                    alert('Viewer could not be loaded in time. Please reload the page or restart the browser.');
                }
            }
        }, 200);
    }

    calculateHeight() {
        if (this.maximized === true) {
            return 'calc(100vh - 48px)';
        } else {
            return 'calc(100vh - 150px)';
        }
    }

    closeViewer() {
        this.onShowViewer.emit(new ShowViewerArgs(false, null, null, null));
    }

    setCurrentTab(code) {
        this.currentTab = code;
        if (this.currentTab !== 'PROFILE' && this.args.variantId !== null) {
            this.profilesConfigure.hideCrossSections();
        }
        if (this.currentTab === 'ROD_CONFIGURE') {
            setTimeout(() => this.fixView(), 1);
        }
    }

    fixView(){
        this.CORE.refreshAspectRatio();
        this.CORE.zoomAll();
    }
}
